import { useState } from "react";
import { hotComics, type Comic } from "@/mocks/comics";

function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group relative overflow-hidden rounded-lg border border-background-600/60 bg-background-900/60 transition-colors hover:border-primary-600/70">
      <div className="relative overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}韩漫封面`}
          className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-950/70 text-xs text-primary-300 backdrop-blur">
            <i className="ri-star-fill text-primary-400"></i>
            {comic.rating}
          </span>
          <div className="flex flex-col items-end gap-1">
            {comic.isVip && (
              <span className="rounded bg-accent-500 px-2 py-0.5 text-[10px] font-bold text-background-50">
                VIP
              </span>
            )}
            <span className="rounded bg-background-950/70 px-2 py-0.5 text-[10px] text-foreground-200 backdrop-blur">
              {comic.status}
            </span>
          </div>
        </div>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-background-950/95 to-background-950/60 p-3.5 pt-8 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-3 text-xs leading-relaxed text-foreground-300">{comic.desc}</p>
          <a
            href="#pricing"
            className="mt-2.5 inline-flex items-center gap-1 text-xs font-semibold text-primary-300"
          >
            立即阅读 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      <div className="p-3.5">
        <h3 className="truncate text-sm font-semibold text-foreground-50">{comic.title}</h3>
        <p className="mt-1 text-xs text-foreground-400">
          {comic.category} · {comic.author} · 更新至 {comic.chapters} 话
        </p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {comic.tags.map((t) => (
            <span
              key={t}
              className="rounded bg-secondary-500/15 px-2 py-0.5 text-[10px] text-secondary-300"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}

export default function HotComics() {
  const [active, setActive] = useState("全部");
  const filters = ["全部", ...hotComics.map((c) => c.category).filter((v, i, a) => a.indexOf(v) === i)];

  const list = active === "全部" ? hotComics : hotComics.filter((c) => c.category === active);

  return (
    <section id="hot" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-5 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
              <i className="ri-fire-line"></i>
              本周热度排行
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              热门韩漫<span className="text-gradient-gold">正在热播</span>
            </h2>
          </div>

          <div className="flex flex-wrap gap-1.5 rounded-full border border-background-600/60 bg-background-900/50 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors md:text-sm ${
                  active === f
                    ? "bg-primary-500 text-background-950"
                    : "text-foreground-300 hover:text-primary-300"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {list.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}